import { fromUnixTime as _fromUnixTime } from 'date-fns';

/**
  Return the date given a timestamp.
  https://date-fns.org/v2.25.0/docs/format
  @method fromUnixTime
  @param {number}                 unixTime    timestamp
  @return {Date}
  @public
*/
export default function fromUnixTime(unixTime: number): Date {
  return _fromUnixTime(unixTime);
}
